import type Owner from '@ember/owner';

import { BillingAddonType, BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensOKRsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	trackingOrigin = 'okrs';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Turn your strategy into measurable results';
		this.descText =
			'Define clear objectives, break them down into measurable goals and sub-goals, and track progress automatically so your entire company stays aligned and focused on what matters most.';

		// TODO: @ŧadcom0: this.readMoreUrl = 'https://help.databox.com/overview-calculated-metrics';

		this.imageLightUrl = '/images/placeholders/placeholder-okr-strategy.svg';

		this.mainActions = [];

		this.trialFeatures = [BillingFeature.OKR];
		this.trialAddonId = BillingAddonType.OKR;

		this.topImageLightUrl = '/images/placeholders/goals.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/goals.svg';

		this.arrowText = 'Click here to get started with your first goal';
	}
}
